import { type FC, memo } from 'react';
import styles from './index.module.scss';
import { Dialog, type DialogProps } from 'evergreen-ui';

interface OwnProps extends DialogProps {
  center?: boolean;
}

const ParrotDialog: FC<OwnProps> = ({ children, ...props }) => {
  return (
    <Dialog
      width={500}
      hasFooter={false}
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEscapePress={false}
      overlayProps={{
        className: `${styles.parrot_overlay} ${props.center ? styles.parrot_center : ''}`,
      }}
      containerProps={{
        className: `${styles.parrot_dialog} ${props.hasHeader ? styles.parrot_header : ''}`,
      }}
      contentContainerProps={{
        className: styles.parrot_content,
      }}
      {...props}
    >
      {props.isShown ? children : null}
    </Dialog>
  );
};

export default memo(ParrotDialog);
